import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Modal, Row, Col, Form } from "react-bootstrap";
import { Chip } from "@mui/material";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { randomId } from "@mui/x-data-grid-generator";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { generateReport, getStatus } from "../../actions/taskAction";
import DateTimeRangePicker from "../../layouts/DateTimeRangePicker";
import SingleMultiSelect from "../../layouts/SingleMultiSelect";

// Add Functionality
function EditToolbar(props) {
  const { onGenerate, onRefresh } = props;
  // const { setRows, setRowModesModel, projectsList, selectedProjects, dispatch, addProject } = props;
  // const addNewProject = () => {
  //   const id = randomId();
  //   setRows((prev) => [
  //     { id, projectDesc: "", deploymentID: "", isNew: true },
  //     ...prev,
  //   ]);
  //   setRowModesModel((prev) => ({
  //     ...prev,
  //     [id]: { mode: GridRowModes.Edit, fieldToFocus: "projectDesc" },
  //   }));
  // };

  // const duplicateProjects = ()=>{
  //   // Check if project lists and selected project list available
  //   // Loop through selected projet list and find the details from selected project
  //   let selectedProjectDetails;

  //   if(selectedProjects.length){
  //     if(projectsList.data.length){
  //       selectedProjectDetails = projectsList.data?.filter((project)=>selectedProjects.includes(project.projectID));
  //     }
  //     // alternative for using modal for confirmation message
  //     // eslint-disable-next-line no-restricted-globals
  //     if(confirm("Are you sure you want to duplicate the records")){
  //       if(selectedProjectDetails.length){
  //         selectedProjectDetails.map((selectedProject)=>{
  //           // Update the row on the UI
  //           const id = randomId();
  //           setRows((prev) => [
  //             { id, projectDesc:selectedProject.projectDesc, clientId: selectedProject.clientId, selectedClient: selectedProject.clientId, status: selectedProject.status, FromDate: selectedProject.FromDate, ToDate:selectedProject.ToDate, isNew: true },
  //             ...prev,
  //           ]);

  //           setRowModesModel((prev) => ({
  //             ...prev,
  //             [id]: { mode: GridRowModes.Edit, fieldToFocus: "projectDesc" },
  //           }));

  //         })
  //       }
  //     }
  //   }
  //  else{
  //   alert("No project has been selected");
  //  }
  // }

  return (
    <GridToolbarContainer>
      <Button
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => onGenerate()}
      >
        Generate
      </Button>

      {/* <Button
        color="primary"
        startIcon={<RefreshIcon />}
        onClick={() => onRefresh()}
      >
        Check Status
      </Button> */}
    </GridToolbarContainer>
  );
}

const LiteReport = () => {
  const [rows, setRows] = useState([]);
  const [formData, setFormData] = useState({});
  const [reportWizardOpen, setReportWizardOpen] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const tasks = useSelector((state) => state.tasks);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const onGenerate = () => {
    setReportWizardOpen(true);
  };

  const onRefresh = () => {
    if (tasks && tasks.taskStatus.data)
      dispatch(getStatus({ url: tasks.taskStatus.data.statusQueryGetUri }));
  };

  const onClose = () => {
    setReportWizardOpen(false);
    setShowErrorMessage("");
    setShowErrorModal(false);
  };

  const onChange = (e) => {
    // Handle DateTimeRangePicker
    if (e && e.dates && e.dateStrings) {
      setFormData((prev) => ({
        ...prev,
        reportRangeStrings: e.dateStrings,
      }));
      console.log("DateTimeRangePicker:", e.dates, e.dateStrings);
      return;
    }

    // Handle SingleMultiSelect components - they pass {name, value} directly
    if (e && e.name !== undefined) {
      setFormData((prev) => ({
        ...prev,
        [e.name]: e.value,
      }));
      return;
    }

    // Handle standard form inputs (with e.target structure)
    if (e && e.target && e.target.name) {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
      return;
    }
  };

  const onSubmit = () => {
    console.log("Test my final form data", formData);

    // Form validation
    if (!formData.selectedDevice || formData.selectedDevice.length === 0) {
      setReportWizardOpen(false);
      setShowErrorMessage("Please select at least one device.");
      setShowErrorModal(true);
      return;
    }
    if (!formData.sentTo || formData.sentTo.length === 0) {
      setReportWizardOpen(false);
      setShowErrorMessage("Please select at least one recipient.");
      setShowErrorModal(true);
      return;
    }
    if (
      !formData.reportRangeStrings ||
      formData.reportRangeStrings.length !== 2 ||
      !formData.reportRangeStrings[0] ||
      !formData.reportRangeStrings[1] ||
      formData.reportRangeStrings[0] === "" ||
      formData.reportRangeStrings[0] === "" ||
      formData.reportRangeStrings[0] === formData.reportRangeStrings[1]
    ) {
      setReportWizardOpen(false);
      setShowErrorMessage("Please select a valid date range.");
      setShowErrorModal(true);
      return;
    }

    setShowErrorMessage(false);
    setShowErrorModal(false);

    const submitData = {
      reportRangeStrings: formData.reportRangeStrings,
      selectedDevice: formData.selectedDevice,
      sentTo: formData.sentTo,
    };
    dispatch(generateReport(submitData));

    const newReport = {
      id: Date.now(),
      Date: new Date(),
      Client: "Salvation Army",
      FromDate: formData.reportRangeStrings[0],
      ToDate: formData.reportRangeStrings[1],
      status: null,
    };

    // setRows((prev) => [...prev, newReport]);// TO-DO: Report status feature

    setRows([]);
    setFormData({
      ...formData,
      reportRangeStrings: ["", ""],
      selectedFloor: [],
      selectedDevice: [],
      sentTo: [],
    });
    setShowSuccessMessage(true);
    setReportWizardOpen(false);

    // Auto-close after 5 seconds
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 5000);
  };

  // Init form data and rows
  useEffect(() => {
    setRows([]);

    setFormData({
      reportRangeStrings: ["", ""],
      selectedFloor: [],
      selectedDevice: [],
      sentTo: [],
      floors: [
        { id: 1, name: "Fridge" },
        { id: 2, name: "Hot Water" },
        { id: 3, name: "Com Area" },
        { id: 4, name: "Floor 2" },
        { id: 5, name: "Floor 3" },
        { id: 6, name: "Floor 4" },
      ],
      devices: [
        { id: 1, name: "Fridge 1", floor: "Fridge" },
        { id: 2, name: "Fridge 2", floor: "Fridge" },
        { id: 3, name: "Fridge 3", floor: "Fridge" },
        { id: 4, name: "Fridge 4", floor: "Fridge" },
        { id: 5, name: "Fridge 5", floor: "Fridge" },
        { id: 6, name: "Fridge 6", floor: "Fridge" },
        { id: 7, name: "Fridge 7", floor: "Fridge" },
        { id: 8, name: "Fridge 8", floor: "Fridge" },
        { id: 9, name: "Fridge 9", floor: "Fridge" },
        { id: 10, name: "Fridge 10", floor: "Fridge" },
        { id: 11, name: "Fridge 11", floor: "Fridge" },
        { id: 12, name: "Fridge 12", floor: "Fridge" },
        { id: 13, name: "Fridge 13", floor: "Fridge" },
        { id: 14, name: "Fridge 14", floor: "Fridge" },
        { id: 15, name: "Fridge 15", floor: "Fridge" },
        { id: 16, name: "Hot Water 1", floor: "Hot Water" },
        { id: 17, name: "Hot Water 2", floor: "Hot Water" },
        { id: 18, name: "Hot Water 3", floor: "Hot Water" },
        { id: 19, name: "Hot Water 4", floor: "Hot Water" },
        { id: 20, name: "Hot Water 5", floor: "Hot Water" },
        { id: 21, name: "Hot Water 6", floor: "Hot Water" },
        { id: 22, name: "Com Area 1", floor: "Com Area" },
        { id: 23, name: "Com Area 2", floor: "Com Area" },
        { id: 24, name: "Com Area 3", floor: "Com Area" },
        { id: 25, name: "Com Area 4", floor: "Com Area" },
        { id: 26, name: "Com Area 5", floor: "Com Area" },
        { id: 27, name: "Com Area 6", floor: "Com Area" },
        { id: 28, name: "Com Area 7", floor: "Com Area" },
        { id: 29, name: "201E", floor: "Floor 2" },
        { id: 30, name: "201W", floor: "Floor 2" },
        { id: 31, name: "202E", floor: "Floor 2" },
        { id: 32, name: "202W", floor: "Floor 2" },
        { id: 33, name: "203E", floor: "Floor 2" },
        { id: 34, name: "203W", floor: "Floor 2" },
        { id: 35, name: "204E", floor: "Floor 2" },
        { id: 36, name: "204W", floor: "Floor 2" },
        { id: 37, name: "205E", floor: "Floor 2" },
        { id: 38, name: "205W", floor: "Floor 2" },
        { id: 39, name: "206E", floor: "Floor 2" },
        { id: 40, name: "206W", floor: "Floor 2" },
        { id: 41, name: "207E", floor: "Floor 2" },
        { id: 42, name: "207W", floor: "Floor 2" },
        { id: 43, name: "208E", floor: "Floor 2" },
        { id: 44, name: "208W", floor: "Floor 2" },
        { id: 45, name: "216E", floor: "Floor 2" },
        { id: 46, name: "216W", floor: "Floor 2" },
        { id: 47, name: "217E", floor: "Floor 2" },
        { id: 48, name: "217W", floor: "Floor 2" },
        { id: 49, name: "218E", floor: "Floor 2" },
        { id: 50, name: "218W", floor: "Floor 2" },
        { id: 51, name: "219E", floor: "Floor 2" },
        { id: 52, name: "219W", floor: "Floor 2" },
        { id: 53, name: "220E", floor: "Floor 2" },
        { id: 54, name: "220W", floor: "Floor 2" },
        { id: 55, name: "221E", floor: "Floor 2" },
        { id: 56, name: "221W", floor: "Floor 2" },
        { id: 57, name: "231E", floor: "Floor 2" },
        { id: 58, name: "231W", floor: "Floor 2" },
        { id: 59, name: "232E", floor: "Floor 2" },
        { id: 60, name: "232W", floor: "Floor 2" },
        { id: 61, name: "233E", floor: "Floor 2" },
        { id: 62, name: "233W", floor: "Floor 2" },
        { id: 63, name: "234E", floor: "Floor 2" },
        { id: 64, name: "234W", floor: "Floor 2" },
        { id: 65, name: "235E", floor: "Floor 2" },
        { id: 66, name: "235W", floor: "Floor 2" },
        { id: 67, name: "236E", floor: "Floor 2" },
        { id: 68, name: "236W", floor: "Floor 2" },
        { id: 69, name: "239E", floor: "Floor 2" },
        { id: 70, name: "239W", floor: "Floor 2" },
        { id: 71, name: "240E", floor: "Floor 2" },
        { id: 72, name: "240W", floor: "Floor 2" },
        { id: 73, name: "241E", floor: "Floor 2" },
        { id: 74, name: "241W", floor: "Floor 2" },
        { id: 75, name: "242E", floor: "Floor 2" },
        { id: 76, name: "242W", floor: "Floor 2" },
        { id: 77, name: "243E", floor: "Floor 2" },
        { id: 78, name: "243W", floor: "Floor 2" },
        { id: 79, name: "244E", floor: "Floor 2" },
        { id: 80, name: "244W", floor: "Floor 2" },
        { id: 81, name: "245E", floor: "Floor 2" },
        { id: 82, name: "245W", floor: "Floor 2" },
        { id: 83, name: "246E", floor: "Floor 2" },
        { id: 84, name: "246W", floor: "Floor 2" },
        { id: 85, name: "301E", floor: "Floor 3" },
        { id: 86, name: "301W", floor: "Floor 3" },
        { id: 87, name: "302E", floor: "Floor 3" },
        { id: 88, name: "302W", floor: "Floor 3" },
        { id: 89, name: "303E", floor: "Floor 3" },
        { id: 90, name: "303W", floor: "Floor 3" },
        { id: 91, name: "304E", floor: "Floor 3" },
        { id: 92, name: "304W", floor: "Floor 3" },
        { id: 93, name: "305E", floor: "Floor 3" },
        { id: 94, name: "305W", floor: "Floor 3" },
        { id: 95, name: "306E", floor: "Floor 3" },
        { id: 96, name: "306W", floor: "Floor 3" },
        { id: 97, name: "307E", floor: "Floor 3" },
        { id: 98, name: "307W", floor: "Floor 3" },
        { id: 99, name: "308E", floor: "Floor 3" },
        { id: 100, name: "308W", floor: "Floor 3" },
        { id: 101, name: "316E", floor: "Floor 3" },
        { id: 102, name: "316W", floor: "Floor 3" },
        { id: 103, name: "317E", floor: "Floor 3" },
        { id: 104, name: "317W", floor: "Floor 3" },
        { id: 105, name: "318E", floor: "Floor 3" },
        { id: 106, name: "318W", floor: "Floor 3" },
        { id: 107, name: "319E", floor: "Floor 3" },
        { id: 108, name: "319W", floor: "Floor 3" },
        { id: 109, name: "320E", floor: "Floor 3" },
        { id: 110, name: "320W", floor: "Floor 3" },
        { id: 111, name: "321E", floor: "Floor 3" },
        { id: 112, name: "321W", floor: "Floor 3" },
        { id: 113, name: "331E", floor: "Floor 3" },
        { id: 114, name: "331W", floor: "Floor 3" },
        { id: 115, name: "332E", floor: "Floor 3" },
        { id: 116, name: "332W", floor: "Floor 3" },
        { id: 117, name: "333E", floor: "Floor 3" },
        { id: 118, name: "333W", floor: "Floor 3" },
        { id: 119, name: "334E", floor: "Floor 3" },
        { id: 120, name: "334W", floor: "Floor 3" },
        { id: 121, name: "335E", floor: "Floor 3" },
        { id: 122, name: "335W", floor: "Floor 3" },
        { id: 123, name: "336E", floor: "Floor 3" },
        { id: 124, name: "336W", floor: "Floor 3" },
        { id: 125, name: "339E", floor: "Floor 3" },
        { id: 126, name: "339W", floor: "Floor 3" },
        { id: 127, name: "340E", floor: "Floor 3" },
        { id: 128, name: "340W", floor: "Floor 3" },
        { id: 129, name: "341E", floor: "Floor 3" },
        { id: 130, name: "341W", floor: "Floor 3" },
        { id: 131, name: "342E", floor: "Floor 3" },
        { id: 132, name: "342W", floor: "Floor 3" },
        { id: 133, name: "343E", floor: "Floor 3" },
        { id: 134, name: "343W", floor: "Floor 3" },
        { id: 135, name: "344E", floor: "Floor 3" },
        { id: 136, name: "344W", floor: "Floor 3" },
        { id: 137, name: "345E", floor: "Floor 3" },
        { id: 138, name: "345W", floor: "Floor 3" },
        { id: 139, name: "346E", floor: "Floor 3" },
        { id: 140, name: "346W", floor: "Floor 3" },
        { id: 141, name: "401E", floor: "Floor 4" },
        { id: 142, name: "401W", floor: "Floor 4" },
        { id: 143, name: "402E", floor: "Floor 4" },
        { id: 144, name: "402W", floor: "Floor 4" },
        { id: 145, name: "403E", floor: "Floor 4" },
        { id: 146, name: "403W", floor: "Floor 4" },
        { id: 147, name: "404E", floor: "Floor 4" },
        { id: 148, name: "404W", floor: "Floor 4" },
        { id: 149, name: "405E", floor: "Floor 4" },
        { id: 150, name: "405W", floor: "Floor 4" },
        { id: 151, name: "406E", floor: "Floor 4" },
        { id: 152, name: "406W", floor: "Floor 4" },
        { id: 153, name: "407E", floor: "Floor 4" },
        { id: 154, name: "407W", floor: "Floor 4" },
        { id: 155, name: "408E", floor: "Floor 4" },
        { id: 156, name: "408W", floor: "Floor 4" },
        { id: 157, name: "416E", floor: "Floor 4" },
        { id: 158, name: "416W", floor: "Floor 4" },
        { id: 159, name: "417E", floor: "Floor 4" },
        { id: 160, name: "417W", floor: "Floor 4" },
        { id: 161, name: "418E", floor: "Floor 4" },
        { id: 162, name: "418W", floor: "Floor 4" },
        { id: 163, name: "419E", floor: "Floor 4" },
        { id: 164, name: "419W", floor: "Floor 4" },
        { id: 165, name: "420E", floor: "Floor 4" },
        { id: 166, name: "420W", floor: "Floor 4" },
        { id: 167, name: "421E", floor: "Floor 4" },
        { id: 168, name: "421W", floor: "Floor 4" },
        { id: 169, name: "431E", floor: "Floor 4" },
        { id: 170, name: "431W", floor: "Floor 4" },
        { id: 171, name: "432E", floor: "Floor 4" },
        { id: 172, name: "432W", floor: "Floor 4" },
        { id: 173, name: "433E", floor: "Floor 4" },
        { id: 174, name: "433W", floor: "Floor 4" },
        { id: 175, name: "434E", floor: "Floor 4" },
        { id: 176, name: "434W", floor: "Floor 4" },
        { id: 177, name: "435E", floor: "Floor 4" },
        { id: 178, name: "435W", floor: "Floor 4" },
        { id: 179, name: "436E", floor: "Floor 4" },
        { id: 180, name: "436W", floor: "Floor 4" },
        { id: 181, name: "439E", floor: "Floor 4" },
        { id: 182, name: "439W", floor: "Floor 4" },
        { id: 183, name: "440E", floor: "Floor 4" },
        { id: 184, name: "440W", floor: "Floor 4" },
        { id: 185, name: "441E", floor: "Floor 4" },
        { id: 186, name: "441W", floor: "Floor 4" },
        { id: 187, name: "442E", floor: "Floor 4" },
        { id: 188, name: "442W", floor: "Floor 4" },
        { id: 189, name: "443E", floor: "Floor 4" },
        { id: 190, name: "443W", floor: "Floor 4" },
        { id: 191, name: "444E", floor: "Floor 4" },
        { id: 192, name: "444W", floor: "Floor 4" },
        { id: 193, name: "445E", floor: "Floor 4" },
        { id: 194, name: "445W", floor: "Floor 4" },
        { id: 195, name: "446E", floor: "Floor 4" },
        { id: 196, name: "446W", floor: "Floor 4" },
      ],
      recipients: [{ id: 1, name: `${user.email}` }],
    });
  }, []);

  // Filter devices based on selected floor
  useEffect(() => {
    if (
      formData.devices &&
      formData.selectedFloor &&
      formData.selectedFloor.length > 0
    ) {
      let filteredDevices = formData.devices.filter((device) =>
        formData.selectedFloor.includes(device.floor)
      );

      // Set filtered devices based on selected floor
      setFormData((prevState) => ({
        ...prevState,
        filteredDevices: filteredDevices,
      }));

      // Autoselect all devices when floor is selected
      setFormData((prevState) => ({
        ...prevState,
        selectedDevice: filteredDevices.map((device) => device.name),
      }));
    } else {
      // Clear filtered devices and selected devices when no floor is selected
      setFormData((prevState) => ({
        ...prevState,
        filteredDevices: [],
        selectedDevice: [],
      }));
    }
  }, [formData.selectedFloor, formData.devices]);

  const projectColumns = [
    // {
    //   field: "Date",
    //   headerName: "Date",
    //   type: "dateTime",
    //   width: 300,
    //   editable: false,
    //   hide: true,
    // },
    // {
    //   field: "FromDate",
    //   headerName: "From",
    //   type: "dateTime",
    //   width: 200,
    //   editable: false,
    //   valueGetter: (params) => {
    //     return params.value;
    //   },
    //   valueFormatter: (params) => {
    //     if (params.value) {
    //       const validDate = new Date(params.value).getTime();
    //       if (validDate) {
    //         return new Date(params.value);
    //       }
    //     }
    //     return "";
    //   },
    // },
    // {
    //   field: "ToDate",
    //   headerName: "To",
    //   type: "dateTime",
    //   width: 200,
    //   editable: false,
    //   valueGetter: (params) => {
    //     return params.value;
    //   },
    //   valueFormatter: (params) => {
    //     if (params.value) {
    //       const validDate = new Date(params.value).getTime();
    //       if (validDate) {
    //         return new Date(params.value);
    //       }
    //     }
    //     return "";
    //   },
    // },
    // {
    //   field: "status",
    //   headerName: "Progress",
    //   width: 150,
    //   editable: true,
    //   renderCell: (params) => {
    //     let label = "New";
    //     if (Number(params.value) === 3) {
    //       label = "Complete";
    //     } else if (Number(params.value) === 2) {
    //       label = "In Progress";
    //     } else if (Number(params.value) === 1) {
    //       label = "Failed";
    //     }
    //     const chipStyle = {
    //       minWidth: "100px",
    //       color: "white",
    //       backgroundColor: (() => {
    //         switch (params.value) {
    //           case 3:
    //             return "#66bb6a"; // Color for "Completed"
    //           case 2:
    //             return "#FFA500"; // Color for "In Progress"
    //           case 1:
    //             return "#d32f2f"; // Color for "Failed"
    //           default:
    //             return "#6ccfe9"; // Default color for other statuses
    //         }
    //       })(),
    //     };
    //     return <Chip label={label} style={chipStyle} />;
    //   },
    // },
  ];

  return (
    <>
      <Box
        sx={{
          height: 500,
          width: "50%",
        }}
      >
        {rows ? (
          <DataGrid
            sx={{
              color: "white",
              bgcolor: "#062545",
              "& .MuiDataGrid-root": {
                bgcolor: "#062545", // main grid container
              },
              "& .MuiDataGrid-main": {
                bgcolor: "#062545", // mid section
              },
              "& .MuiDataGrid-overlay": {
                bgcolor: "#062545",
              },
              "& .MuiDataGrid-menuIconButton": {
                color: "white",
              },
              "& .MuiCheckbox-root": {
                color: "white",
              },

              "& .MuiDataGrid-sortIcon": {
                color: "white",
              },

              "& .MuiTablePagination-root": {
                display: "none",
              },
              "& .MuiDataGrid-cell": {
                border: 0,
              },
              "& .MuiDataGrid-row:hover": {
                bgcolor: "primary.main",
              },
              "& .MuiDataGrid-cell:hover": {
                bgcolor: "none",
              },
              "& .MuiDataGrid-cell:focus": {
                bgcolor: "primary.light",
              },
            }}
            rows={rows}
            columns={projectColumns}
            // pagination={false}
            // editMode="row"
            // getRowId={(row) => row.id}
            // initialState={{
            //   pagination: {
            //     paginationModel: {
            //       pageSize: 10,
            //     },
            //   },
            // }}
            // rowModesModel={rowModesModel}
            // onRowModesModelChange={handleRowModesModelChange}
            // pageSizeOptions={[5]}
            // checkboxSelection
            // onRowSelectionModelChange={handleRowSelectionChange}
            // // disableRowSelectionOnClick
            // onRowEditStop={handleRowEditStop}
            // processRowUpdate={processRowUpdate}
            // onRowClick={handleOnRowClick}
            slots={{
              toolbar: EditToolbar,
            }}
            slotProps={{
              toolbar: { onGenerate, onRefresh },
            }}
            localeText={{
              noRowsLabel: "Click the + Generate button to start a new report",
            }}
          />
        ) : (
          <CircularProgress />
        )}

        {/* Modal Area */}
        {/* Report Wizard Modal */}
        <Modal
          show={reportWizardOpen}
          onHide={onClose}
          centered
          size="lg"
          backdrop="static"
          className="admin-list"
        >
          <Modal.Header
            className="modal-header"
            style={{ backgroundColor: "#062545", color: "white" }}
            closeVariant="red"
          >
            <Modal.Title id="createReport" className="modal-title">
              Report Wizard
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="w-100 modal-body"
            style={{ backgroundColor: "#062545", color: "white" }}
            onChange={onChange}
          >
            <Form
              className="w-100 mb-2 d-flex"
              style={{
                minHeight: "400px",
                backgroundColor: "#062545",
                color: "white",
              }}
            >
              <Row className="w-100">
                <Col xs={12} md={6} className="d-flex flex-column">
                  {/* Floor */}
                  <Form.Group className="mb-3">
                    <Form.Label className="txt-primary">Floor</Form.Label>
                    <SingleMultiSelect
                      name="selectedFloor"
                      mode="multiple"
                      value={formData.selectedFloor}
                      options={
                        formData.floors?.map((floor) => ({
                          value: floor.name,
                          label: <span>{floor.name}</span>,
                        })) || []
                      }
                      onChange={onChange}
                      placeholder="Please select a floor or a unit"
                    />
                  </Form.Group>

                  {/* Device */}
                  <Form.Group className="mb-3">
                    <Form.Label className="txt-primary">Device(s)</Form.Label>

                    {/* Device Multi-Select */}
                    <SingleMultiSelect
                      name="selectedDevice"
                      mode="multiple"
                      value={formData.selectedDevice}
                      options={
                        formData.selectedFloor &&
                        formData.selectedFloor.length > 0
                          ? formData.filteredDevices?.map((device) => ({
                              value: device.name,
                              label: <span>{device.name}</span>,
                            }))
                          : formData.devices?.map((device) => ({
                              value: device.name,
                              label: <span>{device.name}</span>,
                            }))
                      }
                      onChange={onChange}
                      placeholder="Please select device(s)"
                    />
                  </Form.Group>

                  {/* Email To */}
                  <Form.Group className="mb-3">
                    <Form.Label className="txt-primary">Sent to</Form.Label>

                    {/* Email To */}
                    <SingleMultiSelect
                      name="sentTo"
                      mode="tags"
                      value={formData.sentTo}
                      options={
                        formData.recipients?.map((recipient) => ({
                          value: recipient.name,
                          label: <span>{recipient.name}</span>,
                        })) || []
                      }
                      onChange={onChange}
                      placeholder="Please enter recipients email"
                    />
                  </Form.Group>
                </Col>

                <Col xs={12} md={6} className="d-flex flex-column">
                  {/* Date Range Picker */}
                  <Form.Group className="mb-3">
                    <Form.Label className="txt-primary">
                      Report Range
                    </Form.Label>
                    <DateTimeRangePicker
                      // value={formData.reportRange}
                      onChange={onChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer
            className="modal-footer"
            style={{ backgroundColor: "#062545", color: "white" }}
          >
            <Button
              sx={{
                backgroundColor: "#6c757d",
                color: "white",
                borderRadius: "6px",
                minWidth: "100px",
                boxShadow: "none",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#5a6268",
                },
              }}
              variant="contained"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              sx={{
                backgroundColor: "#17a2b8",
                color: "white",
                borderRadius: "6px",
                minWidth: "100px",
                boxShadow: "none",
                textTransform: "none",
                marginLeft: "12px",
                "&:hover": {
                  backgroundColor: "#138496",
                },
              }}
              variant="contained"
              onClick={onSubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Pop-up Modal for Message on submit */}
        <Modal
          show={showSuccessMessage}
          onHide={() => {
            setShowSuccessMessage(false);
          }}
          centered
          size="md"
        >
          <Modal.Header style={{ backgroundColor: "#062545", color: "white" }}>
            <Modal.Title id="modal-modal-title">
              Report Request Submitted
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{ backgroundColor: "#062545", color: "white" }}
            id="modal-modal-description"
          >
            Your report is being generated and will be sent to the specified
            email address shortly.
          </Modal.Body>
        </Modal>

        {/* Warning Modal*/}
        <Modal
          show={showErrorModal}
          onHide={() => setShowErrorModal(false)}
          centered
          size="md"
        >
          <Modal.Header style={{ backgroundColor: "#062545", color: "white" }}>
            <Modal.Title id="modal-modal-title">Warning ❗</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{ backgroundColor: "#062545", color: "white" }}
            id="modal-modal-description"
          >
            {showErrorMessage}
          </Modal.Body>
          <Modal.Footer
            className="modal-footer"
            style={{ backgroundColor: "#062545", color: "white" }}
          >
            <Button
              sx={{
                backgroundColor: "#6c757d",
                color: "white",
                borderRadius: "6px",
                minWidth: "100px",
                boxShadow: "none",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#5a6268",
                },
              }}
              variant="contained"
              onClick={onClose}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    </>
  );
};

export default LiteReport;
